import React from 'react';
import './SpellCardSkeleton.css';

/** Loading placeholder: icon square + content blocks (matches SpellView layout). */
const SpellCardSkeleton = () => (
    <div className="spell-card spell-card--skeleton" aria-hidden="true">
        <div className="spell-skeleton">
            <div className="spell-skeleton-icon" />
            <div className="spell-skeleton-body">
                <div className="spell-skeleton-row">
                    <div className="spell-skeleton-line spell-skeleton-line--title" />
                    <div className="spell-skeleton-line spell-skeleton-line--val" />
                </div>
            </div>
        </div>
    </div>
);

export default SpellCardSkeleton;
